import React, { useEffect } from 'react'
import { useForm } from 'hooks/use-form'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import PropTypes from 'prop-types'

const PaywallEmailInput = ({ onValidChange, validationSchema, error = '' }) => {
    const { values, eventHandlers, errors, touched, changed } = useForm(
        'paywallEmail',
        { email: '' },
        () => {},
        validationSchema,
    )
    useEffect(() => {
        onValidChange(changed.email && !errors.email, values.email)
    }, [changed.email, errors.email, values.email, onValidChange])

    return (
        <SimpleInput
            label="Email (for your receipt)"
            error={(touched.email && errors.email) || error}
            value={values.email}
            onChange={eventHandlers.email}
            type="text"
            placeholder="Enter your email"
            tooltipText="Your email will be used to send a receipt of purchase"
            maxLength={100}
        />
    )
}

PaywallEmailInput.propTypes = {
    onValidChange: PropTypes.func.isRequired,
    validationSchema: PropTypes.object.isRequired,
}

export default React.memo(PaywallEmailInput)
